import {createSelector} from 'reselect';

export const selectUser = (state) => state.user;
// export const selectRoles = state => state.roles.roles;

export const makeSelectInitialLoadUserDone = () =>
  createSelector(selectUser, (userState) => userState.initialLoadUserDone);

export const makeSelectUserToken = () =>
  createSelector(selectUser, (userState) => userState.token);

export const makeSelectIsAuthenticated = () =>
  createSelector(selectUser, (userState) =>
    createSelector(selectUser, (userState) => !!userState.token)
  );
export const makeSelectUserRoles = () =>
  createSelector(selectUser, (userState) =>
    userState.user ? userState.user.roles : []
  );
// createSelector(selectUser, userState => userState.user?userState.user.roles:[],);

export const makeSelectBasicUser = () =>
  createSelector(selectUser, (userState) => ({
    authToken: userState.token,
    ...userState.user,
    roles: userState.user ? userState.user.roles : [],
    // permissions:.permissions
  }));

export const makeSelectSignin = () =>
  createSelector(selectUser, (userState) => ({
    signingIn: userState.signingIn,
    signinSuccess: userState.signinSuccess,
    signinFailed: userState.signinFailed,
    statusText: userState.statusText,
    roles: userState.user ? userState.user.roles : [],
  }));

export const makeSelectSignup = () =>
  createSelector(selectUser, (userState) => ({
    signingUp: userState.signingUp,
    signupSuccess: userState.signupSuccess,
    signupFailed: userState.signupFailed,
    statusText: userState.statusText,
    createdUser: userState.createdUser,
  }));

export const makeSelectForgot = () =>
  createSelector(selectUser, (userState) => ({
    reseting: userState.reseting,
    resetFail: userState.resetFail,
    resetSuccess: userState.resetSuccess,
    resetError: userState.resetError,
  }));
